import { OrderFulfillmentType } from '@/graphql/generatedTypes';
import i18n from '@/utils/i18n';

// Helper function to get mapped transaction type
export const getMappedTransactionType = (type: string): string => {
  switch (type?.toUpperCase()) {
    case OrderFulfillmentType.Picking:
      return i18n.t('OrderFulfillmentType:DELIVERY');
    case OrderFulfillmentType.ReceiveShipment:
    case OrderFulfillmentType.CountAndPack:
      return i18n.t('OrderFulfillmentType:RETURN');
    case OrderFulfillmentType.Delivery:
      return i18n.t('OrderFulfillmentType:DELIVERY');
    case OrderFulfillmentType.Return:
      return i18n.t('OrderFulfillmentType:RETURN');
    default:
      return i18n.t(`OrderFulfillmentType:${type?.toUpperCase()}`);
  }
};
